import SocieteFormController from './societe.form.controller';
import Template from './societe.form.html';

export default {
	bindings: {
		modalInstance: '=',
		genreSociete: '<'
	},
	template: Template /* require('./societe.form.html') */,
	controller: SocieteFormController
};
